exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tree,.tree ul{margin:0;padding:0;list-style:none}.tree ul{margin-left:.5rem;position:relative}.tree ul ul{margin-left:.5em}.tree li{margin:0;padding:0 0 0 1em;position:relative}.tree li:after,.tree li:before{content:\"\";position:absolute;left:0}.tree li:before{border-top:1px solid #003767;top:18px;width:15px;height:0}.tree li:after{border-left:1px solid #003767;height:100%;width:0;top:0}.tree ul>li:last-child:after{height:18px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/main/webapp/app/components/management/queues/tree-view/queues-tree-view.component.css
// module id = 284
// module chunks = 0